<template>
    <div class="article-home">
        <div class="mb-5">
            <a href="https://www.instagram.com/laurenjones.dance/" target="_blank">Instagram</a>
            | <a href="https://www.tiktok.com/@laurenjones.dance" target="_blank">TikTok</a> |
            <a href="https://www.youtube.com/@LaurenJones-dance" target="_blank">YouTube</a>
        </div>
        <p>
            <strong>Lauren Jones</strong> got into West Coast Swing back in 2011 thanks to her wonderful mum but moved
            to Vietnam shortly after. 5 years later, she scooted over to Singapore, fell in love with WCS again as well
            as the community there and social danced her heart out before making her way through Europe in 2019.
        </p>
        <p>
            Although she has dabbled in salsa/bachata and smooth jive on a social level, it is WCS that has her hooked.
            Whilst achieving All-Star level in 2022, it is the social floor that is her happy place; she loves the
            balance between connecting with a partner on the floor and the freedom of self-expression, all to a wide
            range of music genres.
        </p>
        <p>
            Lauren began teaching the dance in 2022 with <nuxt-link to="/chuck">Chuck Brown</nuxt-link>, and you'll
            often see them working together at events.
        </p>
        <p>
            She is over the moon to be working with the inspiring dancers of the community and her aim is to leave each
            person she dances with smiling, be it at her or with her!
        </p>
        <button-donation buttonColor="black"></button-donation>
    </div>
</template>

<script>
export default {
    name: 'ArticleHome',
};
</script>
